// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appbar-reyes-magos p,
.appbar-reyes-magos i {
  color: #db0b27;
}

.appbar-reyes-magos > .app-bar-generic {
  padding-bottom: 3vh;
}

.rm-background {
  /* background: #ebebeb url("../assets/images/reyes-magos/bg.svg") no-repeat; */
  background-color: #ebebeb;
  background-size: 132%;
  background-position: 12% 0;
  height: 100vh;
  overflow: scroll;
  position: fixed;
  z-index: -1;
}

.rm-header-logo > .rm-snow {
  width: 140vw;
}

.rm-content {
  font-family: "RedHatDisplay-Regular", sans-serif !important;
  overflow-y: scroll;
  position: relative;
  top: 19vh;
  width: 100vw;
}

.rm-header-logo {
  left: -10vw;
  position: fixed;
  top: 3vh;
  width: 120vw;
}

.rm-logo {
  margin: 0 auto;
  width: 70vw;
}

.rm-discount-prox,
.rm-dates-info,
.rm-promo-info {
  border-radius: 4px;
  height: 8vh;
  margin: 0 auto;
  margin-top: 2vh;
  padding-top: 1.9vh;
  width: 90vw;
}

.rm-discount-prox {
  background-color: #3a3a3a;
}

.rm-dates-info,
.rm-promo-info {
  background-color: #fff;
}

.rm-promo-info {
  height: auto;
  margin-bottom: 2vh;
  padding-bottom: 3vh;
  padding-right: 2vw;
  width: 88vw;
}

span.rm-icon {
  float: left;
  margin: 0 3.5vw 0 5vw;
}

span.rm-dialog-icon {
  width: 16vw;
  height: 16vw;
  border-radius: 16px;
  background-color: #ececec;
  text-align: center;
  position: relative;
  display: block;
  margin: 0 auto;
}

span.rm-dialog-icon img {
  position: absolute;
  display: inline-block;
  max-height: 100%;
  max-width: 100%;
  width: auto;
  height: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.rm-strong {
  font-weight: 900 !important;
  font-family: "RedHatDisplay-Black" !important;
}

.rm-prox-text,
.rm-discount-info-text,
.rm-info-text,
.rm-info-header,
.rm-info-steps,
.rm-step {
  display: block;
  text-align: left;
  font-size: 3.4vw;
  font-weight: 900;
  line-height: 5vw;
}

.rm-prox-text {
  color: #fff;
}

.rm-info-text {
  color: #2b363b;
  font-weight: normal;
}

.rm-discount-info-text {
  color: #2b363b;
  font-size: 3.4vw;
}

.rm-red {
  color: #db0b27;
  font-size: 3.4vw;
}

.rm-discount-info > .rm-red {
  font-weight: normal;
}

.rm-discount {
  background-color: #fff;
  border-radius: 4px;
  margin: 0 auto;
  padding-top: 1.9vh;
  padding-bottom: 1.9vh;
  width: 90vw;
}

.rm-discount-info,
.rm-discount-price,
.rm-price-legend,
.rm-price-cents {
  display: block;
}

.rm-discount-price {
  margin-top: 2vh;
  font-weight: 900;
}

.rm-price-legend,
.rm-price-cents {
  color: #6ca452;
}

.rm-price-legend {
  font-size: 3.4vw;
  letter-spacing: 0.1em;
}

.rm-price-cents {
  font-size: 2.5em;
  margin-top: 1vh;
}

.rm-price-small {
  color: #2b363b;
  font-size: 0.4em;
}

.rm-step-number {
  background-color: #db0b27;
  color: #fff;
  border-radius: 50%;
  font-size: 0.8em;
  padding: 0.2em 0.8em;
  float: left;
  margin: 3vh 5vw 0 5vw;
  line-height: 1.8em;
}

.rm-step {
  font-weight: 400;
  margin-top: 3vh;
  display: inline-block;
  width: 78%;
}

.rm-link {
  color: #db0b27;
  font-weight: 800;
}

.mymodalreyesmagos {
  font-family: "RedHatDisplay-Regular", sans-serif !important;
  z-index: 4;
  left: 10vw;
  width: 80vw;
  background-color: #fff;
  overflow: auto;
  border-radius: 30px;
  margin: 30% auto;
}

.mymodalreyesmagos:focus-visible,
.mymodalreyesmagos:focus {
  outline-width: 0;
  outline: none;
}

.rm-content-dialog {
  margin-left: 3vw;
  margin-right: 3vw;
  margin-top: 3vh;
  color: #2b363b;
}

.rm-title-dialog {
  display: block;
  font-size: 3.1vh;
  margin-top: 4vh;
  text-align: center;
}

.rm-info-steps-dialog {
  margin: 1.5vh auto;
  line-height: 5vw;
}

.rm-info-steps-dialog .rm-info-steps .rm-step-number {
  margin: 2.5vh 4vw 0 2vw;
}

.rm-info-steps-dialog .rm-info-steps .rm-step {
  margin-top: 2.2vh;
}

.rm-dialog-button {
  color: #db0b27;
  border-radius: 50vw;
  border: #db0b27 1px solid;
  font-size: 4.7vw;
  text-align: center;
  width: 80%;
  margin: 5vh auto;
  padding: 1.5vh;
  font-weight: 800;
}

@media screen and (min-width: 768px) {
  .rm-clock-number {
    font-size: 11vh;
    line-height: 10vh;
  }

  .rm-clock-text {
    font-size: 2.2vh;
  }

  span.rm-icon {
    margin-top: 1vh;
  }

  span.rm-icon img {
    width: 6vw;
  }

  .rm-discount-prox,
  .rm-dates-info {
    height: 9vh;
    padding-top: 1vh;
  }

  span.rm-dialog-icon img {
    width: 8vw;
  }

  .mymodalblackfinde {
    margin: 15% auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/reyes-magos/reyes-magos.css"],"names":[],"mappings":"AAAA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8EAA8E;EAC9E,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2DAA2D;EAC3D,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;;;;;EAME,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;EAC3D,UAAU;EACV,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".appbar-reyes-magos p,\n.appbar-reyes-magos i {\n  color: #db0b27;\n}\n\n.appbar-reyes-magos > .app-bar-generic {\n  padding-bottom: 3vh;\n}\n\n.rm-background {\n  /* background: #ebebeb url(\"../assets/images/reyes-magos/bg.svg\") no-repeat; */\n  background-color: #ebebeb;\n  background-size: 132%;\n  background-position: 12% 0;\n  height: 100vh;\n  overflow: scroll;\n  position: fixed;\n  z-index: -1;\n}\n\n.rm-header-logo > .rm-snow {\n  width: 140vw;\n}\n\n.rm-content {\n  font-family: \"RedHatDisplay-Regular\", sans-serif !important;\n  overflow-y: scroll;\n  position: relative;\n  top: 19vh;\n  width: 100vw;\n}\n\n.rm-header-logo {\n  left: -10vw;\n  position: fixed;\n  top: 3vh;\n  width: 120vw;\n}\n\n.rm-logo {\n  margin: 0 auto;\n  width: 70vw;\n}\n\n.rm-discount-prox,\n.rm-dates-info,\n.rm-promo-info {\n  border-radius: 4px;\n  height: 8vh;\n  margin: 0 auto;\n  margin-top: 2vh;\n  padding-top: 1.9vh;\n  width: 90vw;\n}\n\n.rm-discount-prox {\n  background-color: #3a3a3a;\n}\n\n.rm-dates-info,\n.rm-promo-info {\n  background-color: #fff;\n}\n\n.rm-promo-info {\n  height: auto;\n  margin-bottom: 2vh;\n  padding-bottom: 3vh;\n  padding-right: 2vw;\n  width: 88vw;\n}\n\nspan.rm-icon {\n  float: left;\n  margin: 0 3.5vw 0 5vw;\n}\n\nspan.rm-dialog-icon {\n  width: 16vw;\n  height: 16vw;\n  border-radius: 16px;\n  background-color: #ececec;\n  text-align: center;\n  position: relative;\n  display: block;\n  margin: 0 auto;\n}\n\nspan.rm-dialog-icon img {\n  position: absolute;\n  display: inline-block;\n  max-height: 100%;\n  max-width: 100%;\n  width: auto;\n  height: auto;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n}\n\n.rm-strong {\n  font-weight: 900 !important;\n  font-family: \"RedHatDisplay-Black\" !important;\n}\n\n.rm-prox-text,\n.rm-discount-info-text,\n.rm-info-text,\n.rm-info-header,\n.rm-info-steps,\n.rm-step {\n  display: block;\n  text-align: left;\n  font-size: 3.4vw;\n  font-weight: 900;\n  line-height: 5vw;\n}\n\n.rm-prox-text {\n  color: #fff;\n}\n\n.rm-info-text {\n  color: #2b363b;\n  font-weight: normal;\n}\n\n.rm-discount-info-text {\n  color: #2b363b;\n  font-size: 3.4vw;\n}\n\n.rm-red {\n  color: #db0b27;\n  font-size: 3.4vw;\n}\n\n.rm-discount-info > .rm-red {\n  font-weight: normal;\n}\n\n.rm-discount {\n  background-color: #fff;\n  border-radius: 4px;\n  margin: 0 auto;\n  padding-top: 1.9vh;\n  padding-bottom: 1.9vh;\n  width: 90vw;\n}\n\n.rm-discount-info,\n.rm-discount-price,\n.rm-price-legend,\n.rm-price-cents {\n  display: block;\n}\n\n.rm-discount-price {\n  margin-top: 2vh;\n  font-weight: 900;\n}\n\n.rm-price-legend,\n.rm-price-cents {\n  color: #6ca452;\n}\n\n.rm-price-legend {\n  font-size: 3.4vw;\n  letter-spacing: 0.1em;\n}\n\n.rm-price-cents {\n  font-size: 2.5em;\n  margin-top: 1vh;\n}\n\n.rm-price-small {\n  color: #2b363b;\n  font-size: 0.4em;\n}\n\n.rm-step-number {\n  background-color: #db0b27;\n  color: #fff;\n  border-radius: 50%;\n  font-size: 0.8em;\n  padding: 0.2em 0.8em;\n  float: left;\n  margin: 3vh 5vw 0 5vw;\n  line-height: 1.8em;\n}\n\n.rm-step {\n  font-weight: 400;\n  margin-top: 3vh;\n  display: inline-block;\n  width: 78%;\n}\n\n.rm-link {\n  color: #db0b27;\n  font-weight: 800;\n}\n\n.mymodalreyesmagos {\n  font-family: \"RedHatDisplay-Regular\", sans-serif !important;\n  z-index: 4;\n  left: 10vw;\n  width: 80vw;\n  background-color: #fff;\n  overflow: auto;\n  border-radius: 30px;\n  margin: 30% auto;\n}\n\n.mymodalreyesmagos:focus-visible,\n.mymodalreyesmagos:focus {\n  outline-width: 0;\n  outline: none;\n}\n\n.rm-content-dialog {\n  margin-left: 3vw;\n  margin-right: 3vw;\n  margin-top: 3vh;\n  color: #2b363b;\n}\n\n.rm-title-dialog {\n  display: block;\n  font-size: 3.1vh;\n  margin-top: 4vh;\n  text-align: center;\n}\n\n.rm-info-steps-dialog {\n  margin: 1.5vh auto;\n  line-height: 5vw;\n}\n\n.rm-info-steps-dialog .rm-info-steps .rm-step-number {\n  margin: 2.5vh 4vw 0 2vw;\n}\n\n.rm-info-steps-dialog .rm-info-steps .rm-step {\n  margin-top: 2.2vh;\n}\n\n.rm-dialog-button {\n  color: #db0b27;\n  border-radius: 50vw;\n  border: #db0b27 1px solid;\n  font-size: 4.7vw;\n  text-align: center;\n  width: 80%;\n  margin: 5vh auto;\n  padding: 1.5vh;\n  font-weight: 800;\n}\n\n@media screen and (min-width: 768px) {\n  .rm-clock-number {\n    font-size: 11vh;\n    line-height: 10vh;\n  }\n\n  .rm-clock-text {\n    font-size: 2.2vh;\n  }\n\n  span.rm-icon {\n    margin-top: 1vh;\n  }\n\n  span.rm-icon img {\n    width: 6vw;\n  }\n\n  .rm-discount-prox,\n  .rm-dates-info {\n    height: 9vh;\n    padding-top: 1vh;\n  }\n\n  span.rm-dialog-icon img {\n    width: 8vw;\n  }\n\n  .mymodalblackfinde {\n    margin: 15% auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
